<user-access section="BROKER_PRICE_ALERT" class="no-padding">
  <h3 class="modal-title m-0 text-bold" i18n="@@broker.priceAlertModal.title">{{currencies[0]}} - Price Alert</h3>
  <p *ngIf="!priceAlert?.active" class="mb-2 text-sm" i18n="@@broker.priceAlertModal.subTitle">Set a price and get notified </p>

  <loading *ngIf="loading" class="full">
    <ng-container i18n="@@broker.priceAlertModal.loadingTicker">Loading Price Info</ng-container>
  </loading>

  <error *ngIf="error" class="full">
    {{error}}
  </error>

  <image-text *ngIf="verify" image="assets/images/icons/state-disabled.svg" class="full">
    <p i18n="@@broker.priceAlertModal.verify.text">Please verify your account to continue</p>
    <a class="btn btn-primary" routerLink="/verification" i18n="@@broker.priceAlertModal.verify.button">Verify your account</a>
  </image-text>

  <ng-container *ngIf="!error && !loading && !verify">
    <ng-container [ngSwitch]="priceAlert?.active">
      <price-alert-view *ngSwitchCase="true" [pair]="pair" [price]="price" [priceAlert]="priceAlert" [useGlobalCurrency]="useGlobalCurrency" (save)="onSave()" (close)="onClose()"></price-alert-view>
      <price-alert-form *ngSwitchDefault="" [pair]="pair" [price]="price" [useGlobalCurrency]="useGlobalCurrency" (submit)="onSave()" (close)="onClose()"></price-alert-form>
    </ng-container>
  </ng-container>
</user-access>
